import { io } from "socket.io-client";

const socket = io("https://telemed-server-7uyz.onrender.com"); // Replace with your server URL

export default socket;
